import React, { FunctionComponent, useEffect, useState } from "react"
import ratmService from "./utils/RATMService"
import ratmCrud from "./utils/RATMCrud"
import { AppState } from "src/store"
import { connect } from "react-redux"
import RoleAndTemplateManagementHeader from "./RoleAndTemplateManagementHeader/RoleAndTemplateManagementHeader"
import RoleManagementTable from "./RoleManagement/RoleManagementTable/RoleManagementTable"
import RoleManagementAddOrEditRAA from "./RoleManagement/RoleManagementAddOrEditRAA/RoleManagementAddOrEditRAA"
import RoleManagementDeleteRAA from "./RoleManagement/RoleManagementDeleteRAA/RoleManagementDeleteRAA"
import TemplateManagementTable from "./TemplateManagement/TemplateManagementTable/TemplateManagementTable"
import TemplateManagementAddOrEditTemplate from "./TemplateManagement/TemplateManagementAddOrEditTemplate/TemplateManagementAddOrEditTemplate"
import TemplateManagementDeleteTemplate from "./TemplateManagement/TemplateManagementDeleteTemplate/TemplateManagementDeleteTemplate"
import RoleAndTemplateManagementSplash from "./RoleAndTemplateManagementSplash/RoleAndTemplateManagementSplash"
import "./RoleAndTemplateManagement.css"
interface Props {
    loggedInUserId: number
}

const RoleAndTemplateManagement: FunctionComponent<Props> = (props) => {


    const [state, setState] = useState(ratmService.state)

    const { view, firstLoad, addOrEditRoleId, deleteRoleId, addOrEditTemplateId, deleteTemplateId } = state

    useEffect(() => {
        ratmCrud.loggedInUserId = props.loggedInUserId
        ratmCrud.getRolesAndtemplates()
        //@ts-ignore
        ratmService.webWorker.addEventListener("message", (event: { data: any }) => {
            setState(event.data)
        })
    }, [props.loggedInUserId])

    // console.log("RoleAndTemplateManagement state", state)
    // console.log("RoleAndTemplateManagement ratmService", ratmService)
    // console.log(ratmHash.getStorage(1))

    return (
        <div className="RoleAndTemplateManagement main-content col-sm">
            <RoleAndTemplateManagementHeader />
            {!firstLoad &&
                <>
                    {view === 0 &&
                        <>
                            <RoleManagementTable />
                            {addOrEditRoleId > -1 && <RoleManagementAddOrEditRAA />}
                            {deleteRoleId > -1 && <RoleManagementDeleteRAA />}
                        </>
                    }
                    {view === 1 &&
                        <>
                            <TemplateManagementTable />
                            {addOrEditTemplateId > -1 && <TemplateManagementAddOrEditTemplate />}
                            {deleteTemplateId > -1 && <TemplateManagementDeleteTemplate />}
                        </>
                    }
                </>}
            {firstLoad && <RoleAndTemplateManagementSplash />}
        </div>
    )
}

const mapStateToProps = (state: AppState) => ({
    loggedInUserId: parseInt(state.user.userId)
})

export default connect(mapStateToProps)(RoleAndTemplateManagement)